const Commercial = Object.freeze({
    RESIDENTIALURL: 'dealers/residential/',
    INTERNATIONALURL: 'dealers/international/',
    USA: 'United States',
    INTERNATIONAL: 'International',
    STATESURL: '/states.json',
    COUNTRIESURL: '/countries_iso3.json',
    DEFAULT: 'default',
});

export default Commercial;


// WEBPACK FOOTER //
// ./src/enum/Commercial.enum.jsx